import { API_ROUTES } from "./ApiRoutes";
import { apiClient } from "./http.api";

export const fileApi = {
  // Upload file with progress tracking
  uploadFile: async (file, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(API_ROUTES.FILES.UPLOAD, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });
    return response.data;
  },

  // Move file to final storage
  moveToStorage: async (fileId) => {
    const response = await apiClient.post(API_ROUTES.FILES.MOVE_TO_STORAGE(fileId));
    return response.data;
  },

  // Get file list with pagination and search
  getFileList: async (page = 1, perPage = 10, search = '') => {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString()
    });
    
    if (search) {
      params.append('search', search);
    }

    const response = await apiClient.get(`${API_ROUTES.FILES.LIST}?${params}`);
    return response.data;
  },

  // Get file information
  getFileInfo: async (fileId) => {
    const response = await apiClient.get(API_ROUTES.FILES.GET_BY_ID(fileId));
    return response.data;
  },

  // Get file content (stream)
  getFileContent: async (fileId) => {
    const response = await apiClient.get(API_ROUTES.FILES.GET_CONTENT(fileId));
    return response;
  },

  // Download file
  downloadFile: async (fileId) => {
    const response = await apiClient.get(API_ROUTES.FILES.DOWNLOAD(fileId), {
      responseType: 'blob'
    });
    return response;
  },

  // Get detailed media info
  getMediaInfo: async (fileId) => {
    const response = await apiClient.get(API_ROUTES.FILES.MEDIA_INFO(fileId));
    return response.data;
  },

  // Delete file
  deleteFile: async (fileId) => {
    const response = await apiClient.delete(API_ROUTES.FILES.DELETE(fileId));
    return response.data;
  },

  // Update file status
  updateFileStatus: async (fileId, status) => {
    const response = await apiClient.put(API_ROUTES.FILES.UPDATE_STATUS(fileId), null, {
      params: { status }
    });
    return response.data;
  },

  // Helper function to download file to user's device
  downloadFileToDevice: async (fileId, filename) => {
    try {
      const response = await fileApi.downloadFile(fileId);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      return { success: true };
    } catch (error) {
      console.error('Download error:', error);
      throw error;
    }
  },

  // Helper function to get file stream URL for video/audio players
  getFileStreamUrl: (fileId) => {
    return `${process.env.REACT_APP_API_BASE_URL}${API_ROUTES.FILES.GET_CONTENT(fileId)}`;
  }
};

// Export individual functions for backward compatibility
export const {
  uploadFile,
  moveToStorage,
  getFileList,
  getFileInfo,
  getFileContent,
  downloadFile,
  getMediaInfo,
  deleteFile,
  updateFileStatus,
  downloadFileToDevice,
  getFileStreamUrl,
} = fileApi;
